module.exports = __webpack_public_path__ + "img/44.c362ab92.jpg";